import React from 'react';

import Grid, { Col } from 'Components/Grid';
import LineListIcon, { LineListIconProps } from 'Components/List/LineList/Icon';

import { ArrowLinkButtonProps } from 'Elements/Button/Arrow';

import {
    Container,
    Inner,
    Heading,
    Overview,
    OverviewText,
    ArrowButtonTablet,
    ArrowButtonMobile,
    Wave
} from './OnDemand.styled';
import { Heading as Subheading } from 'Components/List/LineList/Icon/Icon.styled';

export interface Props {
    id: string;
    heading: string;
    overviewTitle: string;
    overviewText: React.ReactNode;
    button: ArrowLinkButtonProps;
    whatYouGet: LineListIconProps;
}

const OnDemand: React.FC<Props> = props => {
    const { id, heading, overviewTitle, overviewText, button, whatYouGet } = props;

    return (
        <Container id={id}>
            <Grid>
                <Col>
                    <Inner>
                        <Grid>
                            <Col>
                                <Heading>{heading}</Heading>
                            </Col>
                            <Col m={6} l={5}>
                                <Overview>
                                    <Subheading>{overviewTitle}</Subheading>
                                    <OverviewText>{overviewText}</OverviewText>
                                    <ArrowButtonTablet {...button} />
                                </Overview>
                            </Col>
                            <Col m={6} l={[7, 12]}>
                                <LineListIcon {...whatYouGet} />
                                <ArrowButtonMobile {...button} />
                            </Col>
                        </Grid>
                    </Inner>
                </Col>
            </Grid>
            <Wave />
        </Container>
    );
};

export default OnDemand;
